;$(function() {

    $('.menu__link_submenu').click(function() {

        $(this).siblings('.menu_submenu').toggleClass('menu_shown');

    });

    $(document).click(function(e) {
        if ($(e.target).parents('.menu_shown').length || $(e.target).hasClass('menu__link_submenu'))
            return;

        if ($(document).find('.menu_shown').length)
            $('.menu_shown').removeClass('menu_shown');
    });

    $('.menu__link_submenu--loged').click(function(e) {
        if ($(window).width() > 900)
            return;

        $(this).siblings('.menu_submenu').removeClass('menu_shown');

        window.location.pathname = '/lk/favorite/';
    });

    $('a.menu__link').on('click touchend', function(e) {
        if(!($(window).width() > 900))
            window.location = $(this).attr('href');
    });

    if($(window).width() < 900)
        $('span.menu__link').on('touchend', function () {
            $(this).click();
        });

});